/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { PermissionDescriptorFromJSON, PermissionDescriptorToJSON, } from './';
export function AccessGrantRequestFromJSON(json) {
    return AccessGrantRequestFromJSONTyped(json, false);
}
export function AccessGrantRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fromOrganisation': !exists(json, 'fromOrganisation') ? undefined : json['fromOrganisation'],
        'toUser': !exists(json, 'toUser') ? undefined : json['toUser'],
        'toOrganisation': !exists(json, 'toOrganisation') ? undefined : json['toOrganisation'],
        'permissions': !exists(json, 'permissions') ? undefined : (json['permissions'].map(PermissionDescriptorFromJSON)),
        'roles': !exists(json, 'roles') ? undefined : json['roles']
    };
}
export function AccessGrantRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fromOrganisation': value.fromOrganisation,
        'toUser': value.toUser,
        'toOrganisation': value.toOrganisation,
        'permissions': value.permissions === undefined ? undefined : (value.permissions.map(PermissionDescriptorToJSON)),
        'roles': value.roles
    };
}
